const style = {
    root: {
        marginLeft: 20,
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
        margin: 16,
        gap: 16,
        alignItems: 'center',
    },
};
export default style;
